import React from 'react';

import { Button } from '$partials/ui';
import { formatLinkBlockToUrl } from '$utilities/format';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').PartnershipCardsBlock}
 */
const PartnershipCards = ({
    backgroundColor,
    partners,
    text,
    title
}) => {
    const bgColor = `bg-surface-panel-${backgroundColor}`;

    return (
        <section className={`col-wrapper-breakout ${bgColor} rounded-lg py-24`}>
            <h2 className='col-padding type-style-sans-h1 w-full sm:w-8/12 md:w-7/12'>
                {title}
            </h2>

            {text && (
                <p className='col-padding type-style-sans-h3 mt-8 w-full sm:w-7/12 md:w-6/12'>
                    {text}
                </p>
            )}

            <div className='flex flex-wrap mt-64 gap-y-8 md:gap-y-16'>
                {partners.map((partner) => {
                    return (
                        <div
                            className='col-padding w-full sm:w-6/12 md:w-4/12'
                            key={partner.id}>
                            <div className='h-full bg-surface-raised p-16 rounded-lg'>
                                <p className='type-style-sans-h3-med'>
                                    {partner.title}
                                </p>

                                {partner.text && (
                                    <p className='type-style-sans-body mt-8'>
                                        {partner.text}
                                    </p>
                                )}

                                {partner.ctaLabel && (
                                    <Button
                                        as='a'
                                        className='mt-16 button-outcome'
                                        href={formatLinkBlockToUrl(partner.ctaLink)}>
                                        {partner.ctaLabel}
                                    </Button>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default PartnershipCards;
